import { PricingPortalAPI } from "../../../apis/pricing-api";
import { handlePostAction } from "../../../utils/event-api-invoke";
import { getDeviceAPIPostSchema, getDeviceAPIDeleteSchema, getDeviceAuditInfoSchema } from "../device/create/schema";

let _isError = false;

const _getPreviousState = (data) => {
  try {
    let _prevState = {};

    _prevState.LongName = data?.device?.LongName || "";
    _prevState.ShortName = data?.device?.shortName || "";
    _prevState.DeviceType = data?.device?.DeviceType?.label || "";
    _prevState.Type = data?.device?.Type?.label || "";
    _prevState.InstallationTime = data?.device?.InstallationTime || 0;
    _prevState.MaintenanceTime = data?.device?.MaintenanceTime || 0;
    _prevState.AgreementCost = data?.device?.AgreementCost || 0;
    _prevState.GMMaterial = data?.device?.GMMaterial || 0;
    _prevState.MyrentokilInstallationTime = data?.device?.MyrentokilInstallationTime || 0;
    _prevState.MyrentokilMaintenanceTime = data?.device?.MyrentokilMaintenanceTime || 0;
    _prevState.HasUninstall = data?.device?.HasUninstall || false;
    _prevState.MinTimePerVisit = data?.device?.MinTimePerVisit || false;
    _prevState.UninstallTimePercentage = data?.device?.UninstallTimePercentage || 0;
    _prevState.InspectionPercentage = data?.device?.InspectionPercentage || 0;
    _prevState.QuantityVisibility = data?.device?.QuantityVisibility || false;


    if (data?.replacementDevice && data.replacementDevice.length > 0) {
      const replacementDevice = data.replacementDevice;
      _prevState.replacementDevice = replacementDevice.map((device) => ({
        StartFrequencyReposition: device.StartFrequencyReposition || "",
        EndFrequencyReposition: device.EndFrequencyReposition || "",
        RepositionPercentage: device.RepositionPercentage || "",
        Id: device.ReplaceDeviceId || "",
        ...(data?.Deleted && { Action: "DELETE" }),
      }));
    }


    return JSON.stringify(_prevState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const _getCurrentState = (data) => {
  try {
    let _currentState = {};

    _currentState.LongName = data?.device?.LongName || "";
    _currentState.ShortName = data?.device?.shortName || "";
    _currentState.DeviceType = data?.device?.DeviceType?.label || "";
    _currentState.Type = data?.device?.Type?.label || "";
    _currentState.InstallationTime = data?.device?.InstallationTime || 0;
    _currentState.MaintenanceTime = data?.device?.MaintenanceTime || 0;
    _currentState.AgreementCost = data?.device?.AgreementCost || 0;
    _currentState.GMMaterial = data?.device?.GMMaterial || 0;
    _currentState.MyrentokilInstallationTime = data?.device?.MyrentokilInstallationTime || 0;
    _currentState.MyrentokilMaintenanceTime = data?.device?.MyrentokilMaintenanceTime || 0;
    _currentState.HasUninstall = data?.device?.HasUninstall || false;
    _currentState.MinTimePerVisit = data?.device?.MinTimePerVisit || false;
    _currentState.UninstallTimePercentage = data?.device?.UninstallTimePercentage || 0;
    _currentState.InspectionPercentage = data?.device?.InspectionPercentage || 0;
    _currentState.QuantityVisibility = data?.device?.QuantityVisibility || false;

    if (data?.replacementDevice && data.replacementDevice.length > 0) {
      const replacementDevice = data.replacementDevice.filter(device => device.deleted ? (device.ReplaceDeviceId && device.deleted) : true);
      _currentState.replacementDevice = replacementDevice.map((device) => ({
        StartFrequencyReposition: device.StartFrequencyReposition || "",
        EndFrequencyReposition: device.EndFrequencyReposition || "",
        RepositionPercentage: device.RepositionPercentage || "",
        ...(device.ReplaceDeviceId && { Id: device.ReplaceDeviceId }),
        Action: device.deleted ? "DELETE" : device.ReplaceDeviceId ? "EDIT" : "CREATE"
      }));
    }
    return JSON.stringify(_currentState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getAuditInfo = (data, auditConfig) => {
  try {
    let _auditSchema = getDeviceAuditInfoSchema();
    let _isDeleted = data?.Deleted;

    _auditSchema.auditInfo[0].shortDesc = data?.device?.shortName;
    _auditSchema.auditInfo[0].currentState = (_isDeleted) ? "{}" : _getCurrentState(data); //If the record is deleted, previousState will be available. The currentState will be available for creation.
    if (auditConfig.editDeviceId) {
      _auditSchema.auditInfo[0].LocationKey = auditConfig.editDeviceId;
      _auditSchema.auditInfo[0].Action = _isDeleted ? "DELETE" : "EDIT";
      _auditSchema.auditInfo[0].previousState = _getPreviousState(auditConfig.formdata);
    } else {
      _auditSchema.auditInfo[0].Action = "CREATE";
    }

    return _auditSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getPostPayload = (data, config) => {
  try {

    let _isDeleted = data?.Deleted;
    let _postSchema = {};
    if (_isDeleted) {
      _postSchema = getDeviceAPIDeleteSchema(config.countryCode, config.businessCode);

      _postSchema.device[0].DeviceId = config.editDeviceId;
      _postSchema.device[0].Id = config.editDeviceId;
      _postSchema.device[0].Deleted = _isDeleted;

    } else {
      _postSchema = getDeviceAPIPostSchema(config.countryCode, config.businessCode);

      _postSchema.device[0].LongName = data?.device?.LongName || "";
      _postSchema.device[0].ShortName = data?.device?.shortName || "";
      _postSchema.device[0].DeviceTypeId = data?.device?.DeviceType?.id || "";
      _postSchema.device[0].TypeId = data?.device?.Type?.id || "";
      _postSchema.device[0].InstallationTime = data?.device?.InstallationTime || 0;
      _postSchema.device[0].MaintenanceTime = data?.device?.MaintenanceTime || 0;
      _postSchema.device[0].AgreementCost = data?.device?.AgreementCost || 0;
      _postSchema.device[0].GMMaterial = data?.device?.GMMaterial || 0;
      _postSchema.device[0].MyrentokilInstallationTime = data?.device?.MyrentokilInstallationTime || 0;
      _postSchema.device[0].MyrentokilMaintenanceTime = data?.device?.MyrentokilMaintenanceTime || 0;
      _postSchema.device[0].HasUninstall = data?.device?.HasUninstall || false;
      _postSchema.device[0].MinTimePerVisit = data?.device?.MinTimePerVisit || false;
      _postSchema.device[0].UninstallTimePercentage = data?.device?.UninstallTimePercentage || 0;
      _postSchema.device[0].InspectionPercentage = data?.device?.InspectionPercentage || 0;
      _postSchema.device[0].QuantityVisibility = data?.device?.QuantityVisibility || false;

      if (config.editDeviceId) {
        _postSchema.device[0].DeviceId = config.editDeviceId;
        _postSchema.device[0].Id = config.editDeviceId;
      }

      if (data?.replacementDevice && data.replacementDevice.length > 0) {
        const devices = data.replacementDevice.filter(device => device.deleted ? (device.ReplaceDeviceId && device.deleted) : true);
        _postSchema.device[0].replacementDevice = devices.map((device) => ({
          StartFrequencyReposition: device.StartFrequencyReposition || "",
          EndFrequencyReposition: device.EndFrequencyReposition || "",
          RepositionPercentage: device.RepositionPercentage || "",
          ReplaceDeviceId: device.ReplaceDeviceId || "",
          Deleted: device.deleted || false

        }));
      }
    }


    return _postSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getReplacementDevice = async (EditDeviceId, settingsConfig) => {
  let response = await PricingPortalAPI.getFilterList(
    settingsConfig.businessCode,
    settingsConfig.countryCode,
    "getReplacementDeviceList",
    "replacepercentagedevice",
    `&deviceid=${EditDeviceId}`
  );
  return response;
}

const saveDevice = async (data, uihandler) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  const {
    editDeviceId,
    settingsConfig: { businessCode, countryCode },
    formdata
  } = uihandler;
  try {
    let _auditInfo = getAuditInfo(data, { editDeviceId, formdata });
    let _postPayload = getPostPayload(data, { editDeviceId, businessCode, countryCode });

    let _postRequest = { ..._postPayload, ..._auditInfo };

    let res = await handlePostAction(_postRequest, "device");
    if (res && res.status && res.status === 200) {
      if (res.data.errorNumber > 0) {
        _isError = true;
        status.errorMessage = res.data.errorDescription;
      } else {
        status.responseStatus = res.status;
      }
    }

  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { saveDevice, getReplacementDevice};
